const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
const SET_IS_RIGHT_SIDEBAR = 'SET_IS_RIGHT_SIDEBAR';

export const createReducer = () => {
  function stateDefault() {
    return {
      pageTitle: null,
      isRightSidebar: false
    };
  }

  const initialState = stateDefault();
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case SET_PAGE_TITLE:
        return {
          ...state,
          pageTitle: action.pageTitle
        };
      case SET_IS_RIGHT_SIDEBAR:
        return {
          ...state,
          isRightSidebar: action.isRightSidebar
        };
      default:
        return state;
    }
  };
};

// ACTIONS CREATOR
export function setPageTitle(pageTitle) {
  return {
    type: SET_PAGE_TITLE,
    pageTitle
  };
}
export function setIsRightSidebar(isRightSidebar) {
  return {
    type: SET_IS_RIGHT_SIDEBAR,
    isRightSidebar
  };
}

// SELECTORS
export const selectPageTitle = state => state.client.pageTitle;
export const selectIsRightSidebar = state => state.client.isRightSidebar;

export default { client: createReducer() };



// WEBPACK FOOTER //
// ./src/mt-react-common/reducer.js